import api from "./api"


const ApiLocation = {
    getAll : ()=>{
        return api.get(`/ptk/location`)
    }
}

export default ApiLocation